import axios from 'axios'
import { addAccessTokenRequestInterceptor } from '../auth/auth'

const SellerApiAxios = axios.create({
  baseURL: `/dashboard/api`,
})

// Let the SellerApi Axios instance use the latest access token
addAccessTokenRequestInterceptor(SellerApiAxios)

export default SellerApiAxios
